import React from 'react';
import { motion } from 'framer-motion';
import { SupportHero } from '../components/SupportHero';
import { InfoCards } from '../components/InfoCards';
import { ResourcesGrid } from '../components/ResourcesGrid';
import { FAQAccordion } from '../components/FAQAccordion';
import { AIAssistant } from '../components/AIAssistant';
import { ContactSupport } from '../components/ContactSupport';
export function Support() {
  return <div className="w-full min-h-screen bg-[#F9FAFB]" data-id="element-11681">
      <SupportHero data-id="element-11682" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-20" data-id="element-11683">
        <InfoCards data-id="element-11684" />
        <ResourcesGrid data-id="element-11685" />
        <FAQAccordion data-id="element-11686" />
        <AIAssistant data-id="element-11687" />
        <ContactSupport data-id="element-11688" />
      </div>
    </div>;
}